import { ItiLink as Link } from 'components';
import { DataTableColumn } from 'components/tables/data-table';
import { UnitActivityDisplay } from 'types';

export const getRowName = (row: any, col: DataTableColumn) => {
  return row?.[col.field]?.['name'];
};

export const unitActivityDataColumns: DataTableColumn[] = [
  {
    width: 50,
    field: 'timestamp',
    label: 'DATE',
    type: 'dateTime',
    getValueLabel: v =>
      !!v ? new Date(v).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }).replace(',', '') : null
  },
  {
    width: 144,
    field: 'action',
    label: 'ACTION'
  },
  {
    width: 144,
    field: 'modifiedBy',
    label: 'USER'
  },
  {
    width: 300,
    field: 'description',
    label: 'DESCRIPTION',
    renderCell: (_, row) => row.description
  },
  {
    width: 144,
    field: 'container',
    label: 'CONTAINER',
    getValue: (unit: UnitActivityDisplay) => unit?.unitNumber,
    renderCell: (unitNumber: string, row: UnitActivityDisplay) =>
      row.prevId !== row.currId && row.currId !== row.nextId ? (
        <Link to={`/units/${row.currId}`}>{unitNumber}</Link>
      ) : (
        <>{unitNumber}</>
      )
  },
  {
    width: 144,
    field: 'chassis',
    label: 'CHASSIS',
    getValue: (unit: UnitActivityDisplay) => unit?.unitNumber,
    renderCell: (unitNumber: string, row: UnitActivityDisplay) =>
      row.prevId !== row.currId && row.currId !== row.nextId ? (
        <Link to={`/units/${row.currId}`}>{unitNumber}</Link>
      ) : (
        <>{unitNumber}</>
      )
  },
  {
    width: 144,
    field: 'genset',
    label: 'GENSET',
    getValue: (unit: UnitActivityDisplay) => unit?.unitNumber,
    renderCell: (unitNumber: string, row: UnitActivityDisplay) =>
      row.prevId !== row.currId && row.currId !== row.nextId ? (
        <Link to={`/units/${row.currId}`}>{unitNumber}</Link>
      ) : (
        <>{unitNumber}</>
      )
  },
  {
    width: 144,
    field: 'gateInTransaction',
    label: 'GATE IN',
    renderCell: transactionId =>
      transactionId === 'N/A' ? <p>N/A</p> : <Link to={`/transactions/${transactionId}`}>{transactionId}</Link>
  },
  {
    width: 144,
    field: 'gateOutTransaction',
    label: 'GATE OUT',
    renderCell: transactionId =>
      transactionId === 'N/A' ? <p>N/A</p> : <Link to={`/transactions/${transactionId}`}>{transactionId}</Link>
  },
  {
    width: 144,
    field: 'booking',
    label: 'BOOKING',
    renderCell: booking => (!booking ? <p>N/A</p> : <Link to={`/bookings/${booking.id}`}>{booking.bookingNumber}</Link>)
  }
];
